import {createAction} from '../../../utils/actions';

export const LANGUAGE_SET = 'LANGUAGE_SET';

export const setLanguage = (data) => (dispatch, getState, container) => dispatch(
    createAction(LANGUAGE_SET, container().api.users.setLanguage(data)),
);



// WEBPACK FOOTER //
// ./src/incab/common/actions/users.js